/** Returns a new Date object for given   */
export const unixTimestampToDate = (timestampInSeconds: number): Date => {
    return new Date(timestampInSeconds * 1000);
}